const pluralRules = new Intl.PluralRules("pl");

/**
 * Format trial duration with proper Polish plural form.
 *
 * Polish plural rules:
 *   one  → 1 dzień
 *   few  → 2-4, 22-24, 32-34... → X dni
 *   many → 0, 5-21, 25-31...   → X dni
 *
 * @param days - Number of trial days
 * @returns Formatted string like "1 dzień", "3 dni", "14 dni"
 */
export function formatTrialDays(days: number): string {
  const form = pluralRules.select(days);
  return form === "one" ? `${days} dzień` : `${days} dni`;
}
